var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardSrc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.29409 4C7.29409 3.7863 7.15828 3.59623 6.95612 3.52698C6.75395 3.45773 6.53013 3.52462 6.3991 3.69343L3.60501 7.29343C3.465 7.47383 3.465 7.72617 3.60501 7.90657L6.3991 11.5066C6.53013 11.6754 6.75395 11.7423 6.95612 11.673C7.15828 11.6038 7.29409 11.4137 7.29409 11.2V9.70651C9.36169 9.76191 10.3402 10.1623 10.824 10.5769C11.2887 10.9751 11.3727 11.4379 11.4676 11.9605C11.4754 12.0038 11.4834 12.0475 11.4916 12.0917C11.5379 12.3398 11.7618 12.5145 12.0137 12.4991C12.2656 12.4836 12.4665 12.2829 12.4822 12.0311C12.5511 10.9234 12.4488 9.30759 11.6597 7.95038C10.9002 6.64407 9.54161 5.64277 7.29409 5.51403V4ZM6.29409 9.7403L4.63293 7.6L6.29409 5.4597V6C6.29409 6.27614 6.51795 6.5 6.79409 6.5C9.01665 6.5 10.1746 7.3857 10.7952 8.45302C11.0169 8.83431 11.1751 9.24786 11.2846 9.66789C10.4596 9.0703 9.09049 8.7 6.79409 8.7C6.51795 8.7 6.29409 8.92386 6.29409 9.2V9.7403Z",
    fill: "#DA191C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSrc);
export default __webpack_public_path__ + "static/media/card-src.92febd65445fd38cca607eba8b7e5bb5.svg";
export { ForwardRef as ReactComponent };